// NBL1_Player Pages
import rules from "../../Data/Rules"
import functions from "../../Data/Functions"
import Verification from "../Steps/Verification"
import Base_Details from "../Steps/BaseDetails"
import Pay from "../Steps/Pay"
// import store from "../../veux/store"

let step1, step2, step4, Countries, Associations, Program, Information, Message, DOB

const PortalAgeCheck = p => v => {
    let Start = functions.FormatDate(v.Age_Start, 'YYYY-MM-DD')
    let End = functions.FormatDate(v.Age_End, 'YYYY-MM-DD')
    console.log(Start, End, DOB)
    if (DOB < Start || DOB > End) {
        return `Your Age must be between ${functions.FormatDate(Start, 'DD-MM-YYYY')} to ${functions.FormatDate(End, 'DD-MM-YYYY')} to qualify for this Program`
    }
    return true
}


// NBL1 Player Step Schema
const Load_NextGen_Player_Steps = () => {
    return {
        Portal: '2024 NextGen Combine Player',
        MainColor: "#f5924c",
        Logo: require(`../../assets/BQLogo2.png`),
        Title: `<h2>2024 Next Gen Combine Registration Form</h2>`,
        Description: `The Next Gen Combine Program (NGP) is aimed at finding the next generation of athlete that could one day represent Queensland. The program will also expose young athletes to a high performance environment, and provide a taste of what to expect if they progress along the High Performance pathway in the future. `,
        Model: {},
        steps: [
            // Step 1
            step1,
            // Step 2
            step2,
            // Step 3
            {
                stepno: 3,
                title: 'Rego',
                valid: true,
                information: `${Message}`,
                Schema: {
                    birthCountry: {
                        type: 'select',
                        label: 'Country of Birth',
                        outlined: true,
                        dense: true,
                        rules: [rules.requiredMsg('Country of Birth is Required')],
                        class: 'mx-1 px-1',
                        items: Countries,
                        value: '',
                        OUG: { Contact_Details: { Type: 3394, Action: "Unique" } }
                    },
                    association: {
                        type: 'select',
                        label: 'Association',
                        outlined: true,
                        dense: true,
                        rules: [rules.requiredMsg('Association is Required')],
                        class: 'mx-1 px-1',
                        items: Associations,
                        returnObject: true,
                        itemText: 'Detail',
                        value: '',
                    },
                    team: {
                        type: 'select',
                        label: 'Choose Program',
                        outlined: true,
                        dense: true,
                        rules: [rules.requiredMsg('Program is Required'), PortalAgeCheck()],
                        class: 'mx-1 px-1',
                        items: Program,
                        returnObject: true,
                        itemText: 'Detail',
                        col: 12,
                        value: '',
                        Role: 1,
                        onInput: (ev, portal) => {
                            ev.obj.value.Association = ev.data.association.Code_id
                            portal.Model.ProductDesc = ev.obj.value.Name
                            portal.Model.Amount = ev.obj.value.Price
                        },
                        OUG: { Contact_Roles: true, Type: "Teams" }
                    }
                },
                PreStep: (thisStep, portal) => {
                    DOB = functions.FormatDate(portal.Model.DOB, 'YYYY-MM-DD')
                },
            },
            // Step 4
            step4,
            // Step 5
            {
                stepno: 5,
                title: 'Finalise',
                valid: true,
                information: `Please press Submit to Finalise your registration`,
                Schema: {},
                PostStep: (thisStep, portal) => {
                    functions.sendEmail(
                        {
                            User_Name: 'NextGen Combine Program',
                            User_Email: 'patrick.mcinerney@basketballqld.net.au',
                            emailstosend: portal.Model.email,
                            Subject: `${portal.Model.team.Detail} Booking Confirmed`,
                            Message: `${portal.Model.team.Terms}`
                        }
                    )
                },
            },
            // Step 6
            {
                stepno: 6,
                title: 'Finish',
                valid: true,
                information: `Thank you for your submitted registration for the 2024 Next Gen Combine.</br></br>
                We have sent you a confirmation email and a receipt of your payment.</br></br>
                If you have any queries regarding the program or your registration please contact <a href="mailto:patrick.mcinerney@basketballqld.net.au">patrick.mcinerney@basketballqld.net.au</a>`,
                Schema: {},
            }
        ]
    }
}



export default {

    LoadSchema: async (Parameters) => {
        step1 = await Verification.LoadSchema(1)
        step2 = await Base_Details.LoadSchema(2)
        step4 = await Pay.LoadSchema(4, Parameters)
        Countries = await functions.GetCountries()
        Associations = await functions.GetCodeBy({ Type: "Associations", Organisation: 292 }, true);
        Program = await functions.getData(`SELECT
                                            Codes.*, Products.*,
                                            (SELECT Messages FROM Codes_Messages WHERE Code_id = 3845 AND Type = 'Trials') AS Information
                                        FROM
                                            Codes
                                            INNER JOIN
                                            Products
                                            ON 
                                                Codes.Code_id = Products.Team_id
                                        WHERE
                                            Codes.State_Champs = 3647 AND
                                            (Codes.Code_id = 3845 OR Codes.Code_id = 3846) AND
                                            Products.Status = 700`, false);

        // TODO replace this line back in to replace 139
        // Codes.Status = 'Active' AND
        // console.log(Program)
        Message = Program[0].Information
        return Load_NextGen_Player_Steps()
    },



}

